export default "__VITE_ASSET__fe721d80__"